export const PlanConst = {
    none:'0',
    light:'1',
    standard:'2',
    professional:'3',
    premium:'4'
}

export default PlanConst;